// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TransactionQuickLinks_ql__MbsuT {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-fash-primary-4);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
}
@media only screen and (max-width: 37.5em) {
  .TransactionQuickLinks_ql__MbsuT {
    grid-column: 1/2;
    grid-row: 2/3;
    width: 95%;
    justify-self: center;
  }
}
.TransactionQuickLinks_ql__content__ErON5 {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  gap: 2rem;
  margin-top: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Transactions/TransactionQuickLinks.module.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,mBAAA;EACA,6CAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;AADF;AAEE;EAPF;IAQI,gBAAA;IACA,aAAA;IACA,UAAA;IACA,oBAAA;EACF;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AACJ","sourcesContent":["@import \"../variables/breakpoints\";\n\n.ql {\n  width: 100%;\n  border-radius: 2rem;\n  background-color: var(--color-fash-primary-4);\n  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n  box-sizing: border-box;\n  padding: 3.5rem 2rem;\n  @media only screen and (max-width: $bp-600) {\n    grid-column: 1/2;\n    grid-row: 2/3;\n    width: 95%;\n    justify-self: center;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    box-sizing: border-box;\n    gap: 2rem;\n    margin-top: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ql": `TransactionQuickLinks_ql__MbsuT`,
	"ql__content": `TransactionQuickLinks_ql__content__ErON5`
};
export default ___CSS_LOADER_EXPORT___;
